export default "__VITE_ASSET__7Qu$V1Lq__"